module.exports = __webpack_public_path__ + "img/motor_2_small.aec05ce0.png";